import styled from "styled-components";
import { DropdownToggle } from "reactstrap";

export const DropdownToggleCustom = styled(DropdownToggle)`
  border-radius: 5px !important;
  margin-left: 5px !important;
`;

export const CustomIcone = {
  marginRight: 7,
  marginBottom: -2,
};

export const CustomIconeDownload = {
  width: "16px",
  height: "16px",
  marginRight: 8,
  marginLeft: -3,
};
